import { OnetrustConsentProvider } from './onetrust-consent.provider'
import { createOptanonWrapper } from './optanon-wrapper/optanon-wrapper'
import { setVariantCookie } from './model/set-variant-cookie'
import { loadOnetrustSdkWithRetry } from './load-one-trust-sdk/load-onetrust-sdk-with-retry'
import { ConsentProviderConfig, LoadConsentProviderPort } from '../ports'
import { EnvironmentConfig, LoggingServicePort } from '../../shared/ports'

export const loadOneTrustConsentProviderFactory = (
  logger: LoggingServicePort,
  envConfig: EnvironmentConfig
) => {
  const loadOnetrustConsentProvider: LoadConsentProviderPort = async (
    config: ConsentProviderConfig,
    onetrustVariantId?: string
  ) => {
    const oneTrustPromise = new Promise<OneTrust>((resolve) => {
      window.OptanonWrapper = createOptanonWrapper(resolve)
    })

    if (onetrustVariantId) {
      setVariantCookie(onetrustVariantId, envConfig.stage)
    }
    /*                                                                        */

    await loadOnetrustSdkWithRetry(config, logger)

    return new OnetrustConsentProvider(await oneTrustPromise)
  }

  return loadOnetrustConsentProvider
}
